<template>
    <div class="schedule-classes__item">
        <div class="schedule-classes__info">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <path d="M0,24V0H24V24Z" fill="none"/>
                <g transform="translate(3 1)">
                    <path d="M24.5,7.167v2h-1a2.006,2.006,0,0,0-2,2v14a2.006,2.006,0,0,0,2,2h14a2.006,2.006,0,0,0,2-2v-14a2.006,2.006,0,0,0-2-2h-1v-2h-2v2h-8v-2Zm-1,4h14v2h-14Zm0,4h14v10h-14Z" transform="translate(-21.5 -7.167)" fill="#747c8f"/>
                </g>
            </svg>
            <span>{{courseClasses.date | formatDateFilter}}</span>
        </div>
        <div class="schedule-classes__info">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <path d="M0,24V0H24V24Z" fill="none"/>
                <g transform="translate(2 2)">
                    <path d="M28.833,18.833a10,10,0,1,0,10,10A10.015,10.015,0,0,0,28.833,18.833Zm0,2a8,8,0,1,1-8,8A7.985,7.985,0,0,1,28.833,20.833Zm-1,2v6.414l4.293,4.293,1.414-1.414-3.707-3.707V22.833Z" transform="translate(-18.833 -18.833)" fill="#747c8f"/>
                </g>
            </svg>
            <span>{{courseClasses.time}}</span>
        </div>
        <div class="schedule-classes__info">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <path d="M0,24V0H24V24Z" fill="none"/>
                <g transform="translate(2 1)">
                    <path d="M24.333,7.167a6,6,0,0,0-6,6c0,4.286,6,11,6,11s6-6.714,6-11A6,6,0,0,0,24.333,7.167Zm0,2a4,4,0,0,1,4,4c0,2.01-2.081,5.36-4,7.859-1.921-2.495-4-5.843-4-7.859A4,4,0,0,1,24.333,9.167Zm0,2a2,2,0,1,0,2,2,2,2,0,0,0-2-2Zm-7.2,10-2.8,7h20l-2.8-7H29.146c-.485.731-.972,1.408-1.42,2h2.455l1.2,3H17.286l1.2-3h2.455c-.448-.592-.935-1.269-1.42-2Z" transform="translate(-14.333 -7.167)" fill="#747c8f"/>
                </g>
            </svg>
            <span>{{courseClasses.address.name}}</span>
        </div>
        <div class="schedule-classes__info">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <path d="M0,24V0H24V24Z" transform="translate(0)" fill="none"/>
                <g transform="translate(0 5)">
                    <path d="M7,35.833a7,7,0,0,0,0,14,7.094,7.094,0,0,0,6.271-4H16v3h6v-3h2v-6H13.287a6.95,6.95,0,0,0-6.287-4Zm0,2a4.975,4.975,0,0,1,4.756,3.328l.232.672H22v2H20v3H18v-3H12.018l-.248.635A5.19,5.19,0,0,1,7,47.833a5,5,0,0,1,0-10Zm0,2a3,3,0,1,0,3,3,3.015,3.015,0,0,0-3-3Zm0,2a1,1,0,1,1-1,1,.985.985,0,0,1,1-1Z" transform="translate(0 -35.833)" fill="#747c8f"/>
                </g>
            </svg>
            <span>ауд. {{courseClasses.classroom}}</span>
        </div>
        <div class="schedule-classes__info">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <path d="M0,24V0H24V24Z" fill="none"/>
                <path d="M12,0,0,5,4,6.668v5.1a2.989,2.989,0,0,0,.992,5.049C6.4,20.028,9.043,22,12,22s5.6-1.972,7.008-5.184A2.989,2.989,0,0,0,20,11.768v-5.1l2-.834V11h2V5Zm0,2.168L18.8,5l-.8.332v2.84A2.988,2.988,0,0,0,17,8H7a2.988,2.988,0,0,0-1,.172V5.332L5.2,5ZM7,10H17a1,1,0,0,1,1,1v1.852l.5.287A.982.982,0,0,1,19,14a1,1,0,0,1-.863.98l-.584.082-.211.551C16.3,18.319,14.256,20,12,20s-4.3-1.682-5.34-4.387l-.211-.551-.586-.08A1,1,0,0,1,5,14a.982.982,0,0,1,.5-.861l.5-.287V11a1,1,0,0,1,1-1Z" fill="#747c8f"/>
            </svg>
            <span>{{courseClasses.groupName}}</span>
        </div>
    </div>
</template>

<script>
  export default {
    name: "ScheduleListCourseClasses",
    props: {
      courseClasses: {
        type: Object,
        required: true
      }
    },
    filters: {
      formatDateFilter: (value) => {
        let date = new Date(Date.parse(value));
        let options = {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
        };
        return date.toLocaleString("ru", options)
      },
    },
  }
</script>
